import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-new-create",
  "use": "icon-new-create-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-new-create\"><path fill=\"#515151\" d=\"M557 467v-405h-45v405h-450v45h450v450h45v-450h405v-45z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol